import { Tbody, Td, Th, Thead, Tr, useTheme } from "@chakra-ui/react";
import { Stack, Table } from "@chakra-ui/react";
import { OptimusChartProps } from "./optimusLineChart";

export const OptimusDataGrid = ({ optimisations }: OptimusChartProps) => {
  const chakraTheme = useTheme();

  // illuma colours
  const illumaColours: string[] = Object.values(chakraTheme.colors.primary);
  
  return (
    <Stack spacing="0" align="center" margin="10">
      <Table variant="simple">
        <Thead >
          <Tr>
            <Th
              color={illumaColours[3]}
              borderColor={illumaColours[2]}
              textAlign="center"
            >
              Date{" "}
            </Th>
            <Th
              color={illumaColours[3]}
              borderColor={illumaColours[2]}
              textAlign="center"
            >
              Optimisation
            </Th>
            <Th
              color={illumaColours[3]}
              borderColor={illumaColours[2]}
              textAlign="center"
            >
              User
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {optimisations?.map((task: any) => (
            <Tr key={task.taskRunId} >
              <Td borderColor={illumaColours[2]} textAlign="center">
                {convertDate(task.createdAt)}
              </Td>
              <Td borderColor={illumaColours[2]} textAlign="center">
                {task.taskName === null? "" : task.taskName}
              </Td>
              <Td borderColor={illumaColours[2]} textAlign="center">
                {task.user === null? "" : task.user.firstName} {task.user === null? "": task.user.lastName}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Stack>
  );
};

export const convertDate = (timestamp: string) => {
  const date = new Date(timestamp);
  return date.toISOString().split("T")[0];
};
